var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"button-wrap"},[_c('V-Button',{attrs:{"callback":_vm.findEmail,"text":'Find Email',"loading":_vm.loading}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }